import { List } from 'store/actions/admin/actions';
import ActionTypes from 'store/actionTypes/admin/actions';
import { ListState } from 'store/reducers/types';
import { updateObject } from 'store/updateObject';
import {
  isNumberAction,
  isStringAction,
  TypedAction,
} from 'types/typeguards/reducerActions';

const emptyTagColumns = [] as const;
type EmptyTagColumns = typeof emptyTagColumns[number];

export type ActionsState = {
  mentorship: ListState<EmptyTagColumns, Record<string, boolean>, 'asc/'>;
  mentorFormation: ListState<EmptyTagColumns, Record<string, boolean>, 'asc/'>;
};

const initialState: ActionsState = {
  mentorship: {
    page: 0,
    tags: {
      '': [],
    },
    search: '',
    activeColumns: {},
    take: 100,
    order: 'asc/',
  },
  mentorFormation: {
    page: 0,
    tags: {
      '': [],
    },
    search: '',
    activeColumns: {},
    take: 100,
    order: 'asc/',
  },
};

const setPage = (
  list: List,
  state: ActionsState,
  action: TypedAction<number>,
) => {
  return updateObject(state, {
    [list]: updateObject(state[list], {
      page: action.value,
    }),
  });
};

const setSearch = (
  list: List,
  state: ActionsState,
  action: TypedAction<string>,
) => {
  return updateObject(state, {
    [list]: updateObject(state[list], {
      search: action.value,
      page: 0,
    }),
  });
};

const setTake = (
  list: List,
  state: ActionsState,
  action: TypedAction<number>,
) => {
  return updateObject(state, {
    [list]: updateObject(state[list], {
      take: action.value,
      page: 0,
    }),
  });
};

const actionsReducer = (
  state = initialState,
  action: { type: string; value: unknown },
) => {
  switch (action.type) {
    // Mentorship
    case ActionTypes.MENTORSHIP_SET_PAGE:
      if (isNumberAction(action)) {
        return setPage('mentorship', state, action);
      }
      console.log('Action type error: setPage');
      return state;

    case ActionTypes.MENTORSHIP_SET_SEARCH:
      if (isStringAction(action)) {
        return setSearch('mentorship', state, action);
      }
      console.log('Action type error: setSearch');
      return state;

    case ActionTypes.MENTORSHIP_SET_TAKE:
      if (isNumberAction(action)) {
        return setTake('mentorship', state, action);
      }
      console.log('Action type error: setTake');
      return state;

    // Mentor Formation
    case ActionTypes.FORMATION_SET_PAGE:
      if (isNumberAction(action)) {
        return setPage('mentorFormation', state, action);
      }
      console.log('Action type error: setPage');
      return state;

    case ActionTypes.FORMATION_SET_SEARCH:
      if (isStringAction(action)) {
        return setSearch('mentorFormation', state, action);
      }
      console.log('Action type error: setSearch');
      return state;

    case ActionTypes.FORMATION_SET_TAKE:
      if (isNumberAction(action)) {
        return setTake('mentorFormation', state, action);
      }
      console.log('Action type error: setTake');
      return state;

    default:
      return state;
  }
};

export default actionsReducer;
